import React, { JSX } from 'react';
import { Field, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import Modal from 'assets/shared/Modal';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type ButtonModalProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    BaseHeadline: Field<string>;
    BaseHeading: Field<string>;
    BaseDescription: Field<string>;
    BaseLink: LinkField;
    BaseLinkType: Field<string>;
    fullScreen: Field<boolean>;
  };
};

const ButtonModal = (props: ButtonModalProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const { fields } = props;

  if (!fields) {
    return <p>No datasource set</p>;
  }

  return (
    <div
      className={classNames(marginSize)}
      id={`btn-modal-${props.rendering?.uid}`}
    >
      <div id="modal-root"></div>
      <Modal
        customClass={fields?.fullScreen?.value ? 'full-page' : ''}
        openBtnLabel="Open modal"
        openBtnIcon="play-filled"
        portalId="modal-root"
        {...fields}
      />
    </div>
  );
};

export default ButtonModal;
